import store from '../store/store';
import CompressionHelper from './CompressionHelper.js';

export default {
    created() {},
    mounted() {},
    data() {
        return {
            langs: {
                subject: {
                    name: '제목',
                    placeholder: '제목을 입력해주세요.',
                },
                size: {
                    name: '규격',
                    actualArea: '제품크기',
                    workArea: '편집크기',
                    coverArea: '표지크기',
                    wingArea: '날개크기',
                    width: '가로',
                    length: '세로',
                    depth: '옆폭',
                    spine: '책등',
                    frontWing: '앞날개',
                    backWing: '뒷날개',
                },
                amount: {
                    name: '수량',
                    description: '수량을 선택해주세요.',
                    guide:
                        '{{ harmonize([' +
                        ' has(min, `최소 ${min}${unit} 부터`), ' +
                        ' has(max, `최대 ${max}${unit} 까지`), ' +
                        ' has(parity, `${parity} 단위로`), ' +
                        ' has(multiple, `${multiple}배수 단위로`), ' +
                        ' has(set, `지정된 값만`), ' +
                        ']) }} 입력할 수 있어요.',
                },
                quantity: {
                    name: '건수',
                    description: '건수를 선택해주세요.',
                },
                binding: {
                    name: '제본',
                    description: '제본방식을 선택해주세요.',
                },
                paper: {
                    name: '용지',
                    description: '용지를 선택해주세요.',
                },
                postpresses: {
                    name: '후가공',
                    description: '후가공을 선택해주세요.',
                },
                addons: {
                    name: '추가구성',
                    description: '본제품 외 별매 제품이에요. 필요한 수량만큼 입력해주세요.',
                },
                message: {
                    name: '특이사항',
                    description: '작업 시 참고해야 할 내용이 있다면 자세히 입력해주세요.',
                    placeholder: '특이사항을 입력해주세요.',
                },
                directInput: '직접입력',
                unit: {
                    bundle: '부',
                    page: 'p',
                    sheet: '매',
                    quantity: '건',
                    mm: '㎜',
                    cm: '㎝',
                    x: '×',
                },
                odd: '홀수',
                even: '짝수',
                validate: {
                    min: '최소 {{min}}{{unit}} 부터 가능해요.',
                    max: '최대 {{max}}{{unit}} 까지 가능해요.',
                    minlen: '{{name}} 길이는 최소 {{min}}{{unit}} 부터 가능해요.',
                    maxlen: '{{name}} 길이는 최대 {{max}}{{unit}} 까지 가능해요.',
                    minlenBySize: '{{name}} 길이는 규격에 따라 최소 {{min}}{{unit}} 부터 가능해요.',
                    maxlenBySize: '{{name}} 길이는 규격에 따라 최대 {{max}}{{unit}} 까지 가능해요.',
                    parity: '{{parity}} 단위로 조정했어요.',
                    multipleOf: '{{multiple}} 배수 단위로 조정했어요.',
                    approximate: '허용된 {{set}} {{unit}} 중, 제일 가까운 값으로 조정했어요.',
                    continueOrder: '',
                    filteredByMaxForPosition: '{{ pp(item, "은/는") }} {{deps}}에 따라 {{max}} 까지 가능해요.',
                    filteredByMaxlenForPosition: '{{ pp(item, "은/는") }} {{deps}} 또는 입력조건에 따라 최대 {{maxlen}} 까지 가능해요.',
                    filteredByOddForPosition: '{{ pp(item, "은/는") }} 홀수 위치만 가능해요.',
                    // filteredByOddForPosition: '{{ pp(item, "은/는") }} {{ pp(deps, "이/가") }} {{depsValue}}일 경우 홀수 위치만 가능해요.',
                },
                inside2PrintingMethodGuides: '내지추가 인쇄방법은 내지와 동일하게 유지돼요. 인쇄색상만 선택할 수 있어요.',
                /***
                postposition: {
                    topic: '은/는', // 주격/보조 주제
                    subject: '이/가', // 주격 조사
                    object: '을/를', // 목적격 조사
                },
                ***/
            },
            snapshots: {},
            isRestoring: false,
        };
    },
    computed: {
        /**
         * @typedef {object}
         * @property {boolean} isProd - True if the environment is production or release.
         * @property {boolean} isDev - True if the environment is development.
         * @property {string} type - The current environment string ('development', 'production', 'release').
         */
        $env() {
            return {
                isProd: process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'release',
                isDev: process.env.NODE_ENV === 'development',
                type: process.env.NODE_ENV,
            };
        },

        /**
         * Lodash instance for utility functions.
         * @returns {lodash}
         */
        $lds() {
            return window._;
        },

        /**
         * URL instance for parsing and manipulating the current URL.
         * @returns {URL}
         */
        $url() {
            return new URL(window.location.href);
        },
    },
    methods: {
        call_api: async (method, url, data, multipart = false, signal = null) => {
            const fullUrl = store.state.app.apiPath + url;

            const config = {
                method: method,
                url: fullUrl,
                data: data,
                signal: signal,
                headers: {},
            };

            if (multipart) {
                config.headers['content-type'] = 'multipart/form-data';
                config.withCredentials = false;
                config.onUploadProgress = function (progressEvent) {
                    let percentage = (progressEvent.loaded * 100) / progressEvent.total;
                    let percentCompleted = Math.round(percentage, 2);
                    store.commit('app/setUploadPercent', percentCompleted);
                }.bind(this);
            } else {
                // Ensure JSON headers for API requests
                config.headers['Accept'] = 'application/json';
                config.headers['Content-Type'] = 'application/json';
            }

            try {
                return await axios(config);
            } catch (e) {
                // HTTP 에러 응답이 있으면 (4xx/5xx) 정상 반환하여 호출부에서 data.success 로 처리
                if (e.response) {
                    return e.response;
                }
                throw {
                    ...e,
                    data: { success: false },
                };
            }
        },
        compress_call_api: async (method, url, data) => {
            const config = {
                method: method,
                url: store.state.app.apiPath + url,
                data: CompressionHelper.compressToBase64(data),
            };

            config.headers = { 'content-type': 'application/octet-stream' };

            try {
                return await axios(config);
            } catch (e) {
                // return e.response;
                throw {
                    ...e,
                    data: { success: false },
                };
            }
        },
        redirectTo(o = { notify: null, route: '/' }) {
            this.notify(o.notify ?? this.langs.validate.continueOrder);
            return this.$router.push({ path: o.route });
        },
        static_asset: (path = '') => '' + path,
        snack: (data = {}) => {
            store.commit('snackbar/createSnack', data);
        },
        notify: (message = null, color = null) => {
            store.commit('snackbar/createSnack', {
                message: message, //
                color: color ?? '#4c82e8',
                timeout: 3500,
            });
        },
        tooltip: (data = {}) => {
            store.commit('tooltip/createTooltip', data);
        },
        template(template = '', values = {}) {
            const __template = this.$lds.template(template, {
                interpolate: /\{\{([\s\S]+?)\}\}/g,
                evaluate: /\{%([\s\S]+?)%\}/g,
                escape: /\{-([\s\S]+?)-\}/g,
            });

            return __template({
                harmonize: (value) =>
                    value
                        .filter(Boolean)
                        .join(', ')
                        .replace(/(이|가|은|는|을|를|부터),\s*/g, '$1 ')
                        .replace(/\s*단위로,\s*/g, ' 및 '),
                has: (value = null, tpl = null) => !this.$lds.isBlank(value) && tpl,
                pp: (value, pair) => this.$lds.postposition(value, pair),
                ...values,
            });
        },
        dump(data = null, html = false) {
            if (!this.$env?.isDev) return;

            let output = '';

            if (html === true) output += `<pre class="text-body-2">`;
            output += JSON.stringify(data, null, 4);
            if (html === true) output += `</pre>`;

            if (html === true) return output;
            else console.log(output);
        },
        format_number: (number = 0) => {
            let rNum = (number / 1).toFixed(0).replace('.', ',');
            return rNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        format_price: (amount = 0) => {
            amount = parseFloat(amount);
            amount = typeof amount == 'number' ? amount : 0.0;

            let currency_setting = store.getters['app/generalSettings'].currency;
            let formated_price = amount.toFixed(currency_setting.no_of_decimals);

            if (currency_setting.truncate_price == 1) {
                if (formated_price > 999999.99 && formated_price < 1000000000) {
                    formated_price = (formated_price / 1000000).toFixed(currency_setting.no_of_decimals) + 'M';
                } else if (formated_price > 1000000000) {
                    formated_price = (formated_price / 1000000000).toFixed(currency_setting.no_of_decimals) + 'B';
                }
            }

            formated_price =
                currency_setting.decimal_separator == '1'
                    ? formated_price.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                    : formated_price.replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');

            switch (currency_setting.symbol_format) {
                case '2':
                    formated_price = formated_price + ' ' + currency_setting.code;
                    break;
                case '3':
                    formated_price = currency_setting.code + ' ' + formated_price;
                    break;
                case '4':
                    formated_price = formated_price + ' ' + currency_setting.code;
                    break;
                default:
                    formated_price = currency_setting.code + formated_price;
            }
            return formated_price;
        },
        is_addon_activated: (key = '') => {
            let addon = store.getters['app/addons'].find((addon) => addon.unique_identifier === key);
            return key && key != '' && typeof addon != 'undefined' && addon.activated == 1;
        },
        is_empty_obj: (obj = {}) => {
            return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
        },
        discount_percent: (price = 0, discount_price = 0) => {
            price = parseFloat(price);
            discount_price = parseFloat(discount_price);

            return price > discount_price ? Math.round((100 * (price - discount_price)) / price) : 0;
        },
        get_random_color: () => {
            var colors = Array(
                'red',
                'pink',
                'purple',
                'deep-purple',
                'indigo',
                'blue',
                'blue',
                'light-blue',
                'cyan',
                'teal',
                'green',
                'light-green',
                'lime',
                'yellow',
                'amber',
                'orange',
                'deep-orange',
                'brown',
                'blue-grey',
                'grey',
            );
            return colors[Math.floor(Math.random() * colors.length)];
        },
        /*/device() {
            let viewportWidth = window.innerWidth;
            if (viewportWidth >= 1904) {
                return 'xl';
            } else if (viewportWidth < 1904 && viewportWidth >= 1264) {
                return 'lg';
            } else if (viewportWidth < 1264 && viewportWidth >= 960) {
                return 'md';
            } else if (viewportWidth < 960 && viewportWidth >= 600) {
                return 'sm';
            } else {
                return 'xs';
            }
        },/**/
        $optional: (p) => eval('this.' + p),
        setSession: (key, status) => {
            let now = new Date();
            let item = {
                status: status,
                expiry: now.getTime() + 3600000,
            };

            localStorage.setItem(key, JSON.stringify(item));
        },
        checkSession: (key) => {
            let item = {};
            if (localStorage.getItem(key)) {
                item = localStorage.getItem(key);
                item = JSON.parse(item);
            }
            let now = new Date();

            return typeof item.expiry == 'undefined' || now.getTime() > item.expiry ? '' : item.status;
        },
        getFileSize: (size, type = 'auto') => {
            if (size === null || size === undefined) return '0B';
            var fileSizeInBytes = parseInt(size) || 0;
            var fileSizeInKB = fileSizeInBytes / 1024;
            var fileSizeInMB = fileSizeInKB / 1024;
            var fileSizeInGB = fileSizeInMB / 1024;
            var fileSizeInTB = fileSizeInGB / 1024;

            if (type === 'auto') {
                if (fileSizeInBytes < 1024) return fileSizeInBytes + 'B';
                if (fileSizeInMB < 1) return fileSizeInKB.toFixed(1) + 'KB';
                if (fileSizeInGB < 1) return fileSizeInMB.toFixed(2) + 'MB';
                if (fileSizeInTB < 1) return fileSizeInGB.toFixed(2) + 'GB';
                return fileSizeInTB.toFixed(2) + 'TB';
            }
            if (type === 'KB') return fileSizeInKB.toFixed(2) + 'KB';
            if (type === 'MB') return fileSizeInMB.toFixed(2) + 'MB';
            if (type === 'GB') return fileSizeInGB.toFixed(2) + 'GB';
            if (type === 'TB') return fileSizeInTB.toFixed(2) + 'TB';
            return fileSizeInBytes + 'B';
        },
        stringCut(str, maxLength) {
            let length = 0;
            let result = '';

            for (const char of str) {
                const charCode = char.charCodeAt(0);

                if (
                    (charCode >= 0x0000 && charCode <= 0x007f) || // 영문 및 특수문자
                    (charCode >= 0x0080 && charCode <= 0x00ff)
                ) {
                    // 한글자모 및 한글음절
                    length += 1;
                } else {
                    length += 2; // 한글 글자는 2로 카운트 (한글자모 및 한글음절)
                }

                if (length <= maxLength) {
                    result += char;
                } else {
                    result += '...';
                    break;
                }
            }

            return result;
        },
        printingOptions(product_type, options) {
            var summary = '';

            summary = this.printingBasicOptions(product_type, options);

            summary += this.printingAddOptions(product_type, options);

            return summary;
        },
        printingBasicOptions(product_type, options) {
            const pt = (product_type || '').toUpperCase();
            if (this.$lds.isEmpty(options)) {
                return '일부 구성이 누락되어 주문할 수 없어요. 삭제 후 다시 담아주세요.';
            } else if (
                ['BOOK', 'BOOKLET', 'CATALOG'].contains(pt) && //
                (this.$lds.isEmpty(options.cover) || this.$lds.isEmpty(options.inside))
            ) {
                return '일부 구성이 누락되어 주문할 수 없어요. 삭제 후 다시 담아주세요.';
            } else if (
                this.$lds.isEmpty(options.basic) || //
                this.$lds.isEmpty(options.basic.size) ||
                this.$lds.isEmpty(options.basic.amount)
            ) {
                return '일부 구성이 누락되어 주문할 수 없어요. 삭제 후 다시 담아주세요.';
            }

            let summary = '';

            summary += `${options.basic.size.product_size.name}`;

            // 책자류, 카탈로그류
            if (['BOOK', 'BOOKLET', 'CATALOG'].contains(pt)) {
                // 수량
                summary += ` / ${options.basic.amount.product_amount.name} 부`;
                if (options.basic.amount.product_quantity.value > 1) {
                    summary += ` / ${options.basic.amount.product_quantity.name} 건`;
                }
                // 표지
                if (!this.$lds.isEmpty(options.cover?.material)) {
                    summary +=
                        `<br /><b>표지 : </b>` + //
                        `${options.cover.material.paper_code.name}` +
                        // ` / ${options.cover.amount.product_amount.name}` +
                        ` / ${options.cover.color.printing_color.name}`;
                    if (options.cover.color?.spot_color?.name) {
                        summary += ` / ${options.cover.color.spot_color.name}`;
                    }
                }
                // 내지
                if (!this.$lds.isEmpty(options.inside?.material)) {
                    summary +=
                        `<br /><b>내지 : </b>` + //
                        `${options.inside.material.paper_code.name}` +
                        ` / ${options.inside.amount.product_amount.name} p` +
                        ` / ${options.inside.color.printing_color.name}`;
                    if (options.inside.color?.spot_color?.name) {
                        summary += ` / ${options.inside.color.spot_color.name}`;
                    }
                }
                // 내지추가
                if (
                    this.$lds.isAccepted(options.addoptions?.params?.is_inside2) && //
                    !this.$lds.isEmpty(options.inside2?.material)
                ) {
                    summary +=
                        `<br /><b>내지추가 : </b>` + //
                        `${options.inside2.material.paper_code.name}` +
                        ` / ${options.inside2.amount.product_amount.name} p` +
                        ` / ${options.inside2.color.printing_color.name}`;
                    if (options.inside2.color?.spot_color?.name) {
                        summary += ` / ${options.inside2.color.spot_color.name}`;
                    }
                }
                // 면지
                if (
                    this.$lds.isAccepted(options.addoptions?.params?.is_startend) && //
                    !this.$lds.isEmpty(options.startend?.material)
                ) {
                    summary +=
                        `<br><b>면지 : </b>` + //
                        `${options.startend.material.paper_code.name}` +
                        ` / ${options.startend.amount.product_amount.name}`;
                }
                // 색간지
                if (
                    this.$lds.isAccepted(options.addoptions?.params?.is_interleaf) && //
                    !this.$lds.isEmpty(options.interleaf?.material)
                ) {
                    summary +=
                        `<br><b>색간지 : </b>` + //
                        `${options.interleaf.material.paper_code.name}` +
                        ` / ${options.interleaf.amount.product_amount.name} 매` +
                        ` / ${options.interleaf.color.printing_color.name}`;
                }
                // 제본
                if (!this.$lds.isEmpty(options.bind?.binding)) {
                    summary += '<br><b>제본 : </b>';

                    if (options.bind.binding.bind_type?.name) {
                        summary += `${options.bind.binding.bind_type.name}`;
                    }
                    if (options.bind.binding.bind_direction?.name) {
                        summary += ` / ${options.bind.binding.bind_direction.name}`;
                        if (
                            options.bind.binding.bind_direction?.edge === 'top' && //
                            options.bind.binding.bind_turnin?.name
                        ) {
                            summary += `(${options.bind.binding.bind_turnin.name})`;
                        }
                    }
                    if (options.bind.binding.bind_wing?.name) {
                        summary += ` / ${options.bind.binding.bind_wing.name}`;
                        if (options.bind.binding.bind_wing?.value != 'none') {
                            summary += `(앞 ${options.bind.binding.bindwing_front.name}, 뒤 ${options.bind.binding.bindwing_back.name})`;
                        }
                    }
                    if (options.bind.binding.bind_color?.name) {
                        summary += ` / ${options.bind.binding.bind_color.name}`;
                    }
                    if (options.bind.binding.plastic_sheet?.name) {
                        summary += ` / ${options.bind.binding.plastic_sheet.name}`;
                    }
                    if (options.bind.binding.bind_stand?.name) {
                        summary += ` / ${options.bind.binding.bind_stand.name}`;
                    }
                }
            }

            // 낱장류
            else if (['SHEET', 'SHEETS'].contains(pt)) {
                // 수량
                summary += ` / ${options.basic.amount.product_amount.name} 매`;
                if (options.basic.amount.product_quantity.value > 1) {
                    summary += ` / ${options.basic.amount.product_quantity.name} 건`;
                }
                // 용지
                if (!this.$lds.isEmpty(options.basic?.material)) {
                    summary +=
                        `<br /><b>용지 : </b>` + //
                        `${options.basic.material.paper_code.name}` +
                        ` / ${options.basic.color.printing_color.name}`;
                    if (options.basic.color?.spot_color?.name) {
                        summary += ` / ${options.basic.color.spot_color.name}`;
                    }
                }
                // 형태
                if (!this.$lds.isEmpty(options.bind?.binding)) {
                    summary += '<br><b>형태 : </b>';

                    if (options.bind.binding.bind_type?.name) {
                        summary += `${options.bind.binding.bind_type.name}`;
                    }
                    if (options.bind.binding.bind_direction?.name) {
                        summary += ` / ${options.bind.binding.bind_direction.name}`;
                    }
                }
            }

            // 달력류
            else if (['*CALENDAR*'].contains(pt)) {
                // 수량
                summary += ` / ${options.basic.amount.product_amount.name} 부`;
                if (options.basic.amount.product_quantity.value > 1) {
                    summary += ` / ${options.basic.amount.product_quantity.name} 건`;
                }
                // 용지(달력류는 내지를 실제용지로 사용함)
                if (!this.$lds.isEmpty(options.inside?.material)) {
                    summary +=
                        `<br /><b>용지 : </b>` + //
                        `${options.inside.material.paper_code.name}` +
                        ` / ${options.inside.amount.product_amount.name} 장` +
                        ` / ${options.inside.color.printing_color.name}`;
                    if (options.inside.color?.spot_color?.name) {
                        summary += ` / ${options.inside.color.spot_color.name}`;
                    }
                }
                // 제본
                if (!this.$lds.isEmpty(options.bind?.binding)) {
                    summary += '<br><b>제본 : </b>';

                    if (options.bind.binding.bind_type?.name) {
                        summary += `${options.bind.binding.bind_type.name}`;
                    }
                    if (options.bind.binding.bind_direction?.name) {
                        summary += ` / ${options.bind.binding.bind_direction.name}`;
                        summary += `(${options.bind.binding.bind_turnin.name})`;
                    }
                    if (options.bind.binding.bind_color?.name) {
                        summary += ` / ${options.bind.binding.bind_color.name}`;
                    }
                    if (options.bind.binding.bind_stand?.name) {
                        summary += ` / ${options.bind.binding.bind_stand.name}`;
                    }
                }
            }

            // 실사출력류, 배너류, 현수막류
            else if (['LARGEFORMAT'].contains(pt)) {
                // 수량
                summary += ` / ${options.basic.amount.product_amount.name} 매`;
                if (options.basic.amount.product_quantity.value > 1) {
                    summary += ` / ${options.basic.amount.product_quantity.name} 건`;
                }
                // 용지
                if (!this.$lds.isEmpty(options.basic?.material)) {
                    summary +=
                        `<br /><b>용지 : </b>` + //
                        `${options.basic.material.paper_code.name}` +
                        ` / ${options.basic.printing.printing_method.name}`;
                }
            }

            //스티커 (아직 없음)
            else if (['STICKER'].contains(pt)) {
                summary += '<div class="pb-1">' + options.basic.material?.paper_code.name + ' / ' + options.basic.color?.printing_color.name;
                summary += ' / ' + options.basic.coating?.coating_type.name;

                if (options.basic.size.background_margin?.value) {
                    summary += ' / ' + options.basic.size?.background_margin.name;
                }

                if (options.basic.diecutting?.diecut_type) {
                    summary += '<br />' + options.basic.diecutting?.diecut_type.name + ' / ' + options.basic.diecutting?.diecut_number.name;
                }

                summary += '</div>';
            }

            //NCR지 (아직 없음)
            else if (['NCR'].contains(pt)) {
                summary +=
                    '<br /><b>제본 : </b>' +
                    options.bind.binding.bind_type.name +
                    ' / ' +
                    options.bind.binding.edit_content.name +
                    ' / ' +
                    options.bind.binding.bind_direction.name;

                summary +=
                    '<br /><b>상지 : </b>' +
                    options.upper.material.paper_code.name +
                    ' / 전면:' +
                    options.upper.color.frontprinting_color.name +
                    ', 후면:' +
                    options.upper.color.backprinting_color.name;

                if (options.bind.binding.bind_type.value == 'u-m-l') {
                    summary +=
                        '<br /><b>중지 : </b>' +
                        options.middle.material.paper_code.name +
                        ' / 전면:' +
                        options.middle.color.frontprinting_color.name +
                        ', 후면:' +
                        options.middle.color.backprinting_color.name;
                }

                summary +=
                    '<br /><b>하지 : </b>' +
                    options.lower.material.paper_code.name +
                    ' / 전면:' +
                    options.lower.color.frontprinting_color.name +
                    ', 후면:' +
                    options.lower.color.backprinting_color.name;
            }

            //라벨 (아직 없음)
            else if (['LABEL'].contains(pt)) {
                summary +=
                    '<div class="pb-1">' + //
                    options.basic.material?.paper_code.name +
                    ' / ' +
                    options.basic.color?.printing_color.name;
                if (options.basic.color?.spot_color?.name) {
                    summary += ` / ${options.basic.color.spot_color.name}`;
                }
                summary +=
                    '<div class="pb-1">' +
                    options.basic.size?.shape_type?.name +
                    ' / ' +
                    options.basic.diecutting?.diecut_type?.name +
                    ' / ' +
                    options.basic.diecutting?.diecut_method?.name;
                summary +=
                    '<div class="pb-1">' +
                    options.basic.coating?.coating_type?.name +
                    ' / ' +
                    options.basic.cutting?.cut_method?.name +
                    ' / ' +
                    options.basic.cutting?.cut_type?.name;
                summary += '</div>';
            }

            // 기타 등등
            else {
                // 수량
                summary += ` / ${options.basic.amount.product_amount.name} 매`;
                if (options.basic.amount.product_quantity.value > 1) {
                    summary += ` / ${options.basic.amount.product_quantity.name} 건`;
                }
                // 용지
                if (!this.$lds.isEmpty(options.basic?.material)) {
                    summary +=
                        `<br /><b>용지 : </b>` + //
                        `${options.basic.material.paper_code.name}` +
                        ` / ${options.basic.color.printing_color.name}`;
                    if (options.basic.color?.spot_color?.name) {
                        summary += ` / ${options.basic.color.spot_color.name}`;
                    }
                }
            }

            return summary;
        },

        // PHP Helpers.php::postpress_summary() 함께 확인
        printingAddOptions(product_type, options) {
            if (this.$lds.isEmpty(options)) {
                return '';
            }

            let summary = '';

            if (!this.$lds.isEmpty(options.design)) {
                if (options.design.designedit_type.value != 'none') {
                    summary += '<div class="ma-0">' + options.design.designedit_type.name;
                    summary += '/' + options.design.design_difficulty.name + '</div>';
                }
            }

            if (!this.$lds.isEmpty(options.postpress)) {
                if (this.$lds.isAccepted(options.postpress.chk_postpresses?.is_cutting)) {
                    var _c = options.postpress.cutting || {};
                    var _cParts = [
                        _c.cut_type?.name,
                        _c.cut_sizetype?.name && _c.cut_width?.name && _c.cut_length?.name
                            ? _c.cut_sizetype.name + '(' + _c.cut_width.name + '*' + _c.cut_length.name + ')'
                            : _c.cut_sizetype?.name || null,
                        _c.cut_margin?.name,
                        _c.cut_number != null ? String(_c.cut_number) : null,
                    ].filter(Boolean);
                    if (_cParts.length > 0) {
                        summary += '<div class="ma-0"><b>재단 : </b>' + _cParts.join('/') + '</div>';
                    } else {
                        summary += '<div class="ma-0"><b>재단 : </b>기본재단</div>';
                    }
                }

                if (this.$lds.isAccepted(options.postpress.chk_postpresses?.is_coating)) {
                    if (product_type == 'book' || product_type == 'catalog') {
                        summary += '<div class="ma-0"><b>표지코팅 : </b>' + options.postpress.coating.covercoating_type.name + '</div>';

                        if (
                            !this.$lds.isEmpty(options.postpress.coating.insidecoating_type) && //
                            options.postpress.coating.insidecoating_type.value != 'none'
                        ) {
                            summary += '<div class="ma-0"><b>내지코팅 : </b>' + options.postpress.coating.insidecoating_type.name + '</div>';
                        }
                    } else {
                        summary += '<div class="ma-0"><b>코팅 : </b>' + options.postpress.coating.coating_type.name + '</div>';
                    }
                }

                if (this.$lds.isAccepted(options.postpress.chk_postpresses?.is_scoring)) {
                    summary += '<div class="ma-0"><b>오시 : </b>' + options.postpress.scoring.score_line.name + '</div>';
                }

                if (this.$lds.isAccepted(options.postpress.chk_postpresses?.is_folding_scoring)) {
                    summary +=
                        `<div class="ma-0"><b>오시+접지 : </b>` + //
                        `${options.postpress.folding_scoring.score_line.name} / ${options.postpress.folding_scoring.folding_type.name}` +
                        `</div>`;
                }

                if (this.$lds.isAccepted(options.postpress.chk_postpresses?.is_folding)) {
                    summary += '<div class="ma-0"><b>접지 : </b>' + options.postpress.folding.folding_type.name + '</div>';
                }

                if (this.$lds.isAccepted(options.postpress.chk_postpresses?.is_perforating)) {
                    summary += '<div class="ma-0"><b>미싱 : </b>' + options.postpress.perforating.perforate_line.name + '</div>';
                }

                if (this.$lds.isAccepted(options.postpress.chk_postpresses?.is_partialcoating)) {
                    summary += '<div class="ma-0"><b>부분코팅 : </b>' + options.postpress.partialcoating.coating_type.name + '</div>';
                }
                if (this.$lds.isAccepted(options.postpress.chk_postpresses?.is_foiling)) {
                    summary +=
                        '<div class="ma-0"><b>디지털 박 : </b>' +
                        options.postpress.foiling.order_section.name +
                        '/' +
                        options.postpress.foiling.foil_position.name +
                        '-' +
                        options.postpress.foiling.foil_type.name +
                        '/' +
                        options.postpress.foiling.foil_area.name +
                        '(' +
                        options.postpress.foiling.foil_width.name +
                        '*' +
                        options.postpress.foiling.foil_length.name +
                        ')</div>';

                    if (options.postpress.foiling?.is_foil2) {
                        summary +=
                            '<div class="ma-0"><b>디지털 박 2 : </b>' +
                            options.postpress.foiling.order_section2.name +
                            '/' +
                            options.postpress.foiling.foil_position2.name +
                            '-' +
                            options.postpress.foiling.foil_type2.name +
                            '/' +
                            options.postpress.foiling.foil_area2.name +
                            '(' +
                            options.postpress.foiling.foil_width2.name +
                            '*' +
                            options.postpress.foiling.foil_length2.name +
                            ')</div>';
                    }

                    if (options.postpress.foiling?.is_foil3) {
                        summary +=
                            '<div class="ma-0"><b>디지털 박 3 : </b>' +
                            options.postpress.foiling.order_section3.name +
                            '/' +
                            options.postpress.foiling.foil_position3.name +
                            '-' +
                            options.postpress.foiling.foil_type3.name +
                            '/' +
                            options.postpress.foiling.foil_area3.name +
                            '(' +
                            options.postpress.foiling.foil_width3.name +
                            '*' +
                            options.postpress.foiling.foil_length3.name +
                            ')</div>';
                    }
                }
                if (this.$lds.isAccepted(options.postpress.chk_postpresses?.is_pressing)) {
                    summary +=
                        '<div class="ma-0"><b>형압 : </b>' +
                        options.postpress.pressing.order_section.name +
                        '/' +
                        options.postpress.pressing.press_type.name +
                        '/' +
                        options.postpress.pressing.press_area.name +
                        '(' +
                        options.postpress.pressing.press_width.name +
                        '*' +
                        options.postpress.pressing.press_length.name +
                        ')</div>';

                    if (options.postpress.pressing?.is_press2) {
                        summary +=
                            '<div class="ma-0"><b>형압2 : </b>' +
                            options.postpress.pressing.order_section2.name +
                            '/' +
                            options.postpress.pressing.press_type2.name +
                            '/' +
                            options.postpress.pressing.press_area2.name +
                            '(' +
                            options.postpress.pressing.press_width2.name +
                            '*' +
                            options.postpress.pressing.press_length2.name +
                            ')</div>';
                    }

                    if (options.postpress.pressing?.is_press3) {
                        summary +=
                            '<div class="ma-0"><b>형압3 : </b>' +
                            options.postpress.pressing.order_section3.name +
                            '/' +
                            options.postpress.pressing.press_type3.name +
                            '/' +
                            options.postpress.pressing.press_area3.name +
                            '(' +
                            options.postpress.pressing.press_width3.name +
                            '*' +
                            options.postpress.pressing.press_length3.name +
                            ')</div>';
                    }
                }

                if (this.$lds.isAccepted(options.postpress.chk_postpresses?.is_diecutting)) {
                    summary +=
                        '<div class="ma-0"><b>톰슨 : </b>' +
                        options.postpress.diecutting?.order_section?.name +
                        '/' +
                        options.postpress.diecutting?.diecut_type?.name +
                        '/' +
                        options.postpress.diecutting?.diecut_number?.name +
                        '</div>';
                }
                if (this.$lds.isAccepted(options.postpress.chk_postpresses?.is_gluing)) {
                    summary += '<div class="ma-0"><b>접착 : </b>' + options.postpress.gluing?.gluing_type?.name + '</div>';
                }
                if (this.$lds.isAccepted(options.postpress.chk_postpresses?.is_laminating)) {
                    summary += '<div class="ma-0"><b>라미네이팅 : </b>' + options.postpress.laminating?.laminating_amount?.name + '</div>';
                }
                if (this.$lds.isAccepted(options.postpress.chk_postpresses?.is_epoxing)) {
                    summary += '<div class="ma-0"><b>디지털 에폭시 : </b>' + options.postpress.epoxing?.epoxy_type?.name + '</div>';
                }

                if (this.$lds.isAccepted(options.postpress.chk_postpresses?.is_taping)) {
                    summary += '<div class="ma-0"><b>테잎 : </b>' + options.postpress.taping?.tape_type?.name + '</div>';
                }
                if (this.$lds.isAccepted(options.postpress.chk_postpresses?.is_windowprocessing)) {
                    summary += '<div class="ma-0"><b>창문가공 : </b>' + options.postpress.windowprocessing.window_size.name + '</div>';
                }
                if (this.$lds.isAccepted(options.postpress.chk_postpresses?.is_punching)) {
                    summary +=
                        '<div class="ma-0"><b>타공 : </b>' +
                        options.postpress.punching.punching_number.name +
                        ' - ' +
                        options.postpress.punching.punching_size.name +
                        '</div>';
                }
                if (this.$lds.isAccepted(options.postpress.chk_postpresses?.is_rounding)) {
                    summary += '<div class="ma-0"><b>귀도리 : </b>' + options.postpress.rounding.rounding_type.name + '</div>';
                    if (options.postpress.rounding.rounding_type.value == 'select') {
                        summary += ' - ';
                        if (options.postpress.rounding.rounding_position.tl) summary += ' 좌상';
                        if (options.postpress.rounding.rounding_position.bl) summary += ' 좌하';
                        if (options.postpress.rounding.rounding_position.tr) summary += ' 우상';
                        if (options.postpress.rounding.rounding_position.br) summary += ' 우하';
                    }
                    summary += ' - ' + options.postpress.rounding.rounding_diameter.name + '</div>';
                }

                //배너거치대
                if (this.$lds.isAccepted(options.postpress.chk_postpresses?.is_bannerstand)) {
                    summary +=
                        '<div class="ma-0"><b>거치대 : </b>' +
                        options.postpress.bannerstand.bannerstand_section.name +
                        ' / ' +
                        options.postpress.bannerstand.bannerstand_number.name +
                        '</div>';
                }

                //현수막 각목
                if (this.$lds.isAccepted(options.postpress.chk_postpresses?.is_woodenpole)) {
                    summary += '<div class="ma-0"><b>각목 : </b>' + options.postpress.woodenpole.woodenpole_type.name + '</div>';
                }
            }

            if (options.product_addon_items && options.product_addon_items.length > 0) {
                summary += '<div class="ma-0"><b>추가구성제품 : </b>';
                options.product_addon_items.forEach(function (item) {
                    var line = item.addon_product_name;
                    if (item.selected_option_name) line += ' (' + item.selected_option_name + ')';
                    line += ' x' + item.quantity;
                    if (item.total_price) line += ' (' + parseInt(item.total_price).toLocaleString() + '원)';
                    summary += '<div class="ma-0 ms-2">' + line + '</div>';
                });
                summary += '</div>';
            }

            return summary;
        },
        productOptions(product_type, product_options) {
            var summary = '';

            // console.log('cart-item product_options', product_options);
            if (product_options?.parcel_price) {
                summary += '배송비: ' + this.format_price(product_options.parcel_price);
                summary += '<br />무게: ' + product_options.weight + 'kg';
                summary += '<br />포장박스: ' + product_options.box + '개';
                summary += '<br />작업예정일: ' + product_options.expect_output_day + '일';
            }

            return summary;
        },

        printOrderCode(order_code, is_date = true) {
            if (!order_code) return '';
            // 신규 형식: OD + YYMMDD(6) + NNNNNN(6) = 14자
            if (/^OD\d{12}$/.test(order_code)) {
                const yymmdd = order_code.substr(2, 6);
                const seq = parseInt(order_code.substr(8, 6), 10);
                let display;
                if (seq <= 9999) {
                    display = yymmdd + '-' + String(seq).padStart(4, '0');
                } else {
                    const hi = Math.floor(seq / 10000);
                    const lo = seq % 10000;
                    display = yymmdd + '-' + String(hi).padStart(2, '0') + '-' + String(lo).padStart(4, '0');
                }
                if (is_date) {
                    const date = yymmdd.substr(0, 2) + '.' + yymmdd.substr(2, 2) + '.' + yymmdd.substr(4, 2);
                    return display + ' ( ' + date + ' )';
                }
                return display;
            }
            // 구 형식: OD + YYMMDD(6) + HIS(6) + rand(2) = 16자
            let code = order_code.substr(8, 8);
            let date = order_code.substr(2, 2) + '.' + order_code.substr(4, 2) + '.' + order_code.substr(6, 2);
            let print = code;
            if (is_date == true) {
                print += ' ( ' + date + ' )';
            }
            return print;
        },

        printOrderDetailCode(order_detail_code, is_date = true) {
            // 신규 형식: OD + YYMMDD(6) + NNNNNN(6) + -NN
            if (/^OD\d{12}-\d{2}$/.test(order_detail_code)) {
                const yymmdd = order_detail_code.substr(2, 6);
                const seq = parseInt(order_detail_code.substr(8, 6), 10);
                const itemSeq = order_detail_code.substr(15, 2);
                let orderDisplay;
                if (seq <= 9999) {
                    orderDisplay = yymmdd + '-' + String(seq).padStart(4, '0');
                } else {
                    const hi = Math.floor(seq / 10000);
                    const lo = seq % 10000;
                    orderDisplay = yymmdd + '-' + String(hi).padStart(2, '0') + '-' + String(lo).padStart(4, '0');
                }
                let display = orderDisplay + '-' + itemSeq;
                if (is_date) {
                    const date = yymmdd.substr(0, 2) + '.' + yymmdd.substr(2, 2) + '.' + yymmdd.substr(4, 2);
                    return display + ' ( ' + date + ' )';
                }
                return display;
            }
            // 구 형식
            let code = order_detail_code.substr(8, 8) + '-' + order_detail_code.substr(17, 2);
            let date = order_detail_code.substr(2, 2) + '.' + order_detail_code.substr(4, 2) + '.' + order_detail_code.substr(6, 2);
            let print = code;
            if (is_date == true) {
                print += ' ( ' + date + ' )';
            }
            return print;
        },
    },
};
